import { toastStore } from 'shared/ui'
import { WorkflowsApi } from 'entities/Workflow'
import type { IResponseFilterSegment } from 'entities/Segment'

export class WorkflowEnrollModalStore {
  enrollContacts = (workflowId: string, contactIds: number[], applyFilters: boolean) =>
    WorkflowsApi.enrollIntoWorkflow(
      {
        contact_ids: contactIds,
        apply_trigger_filters: applyFilters,
      },
      workflowId
    ).then(
      () => {
        toastStore.add({
          type: 'success',
          title: `Contact${contactIds.length > 1 ? 's' : ''} will be enrolled in workflow`,
        })

        return true
      },
      () => {
        toastStore.add({
          type: 'error',
          title: `Unable to engage contact${contactIds.length > 1 ? 's' : ''}`,
        })

        return false
      }
    )

  enrollContactsByFilters = ({
    workflowId,
    applyFilters,
    filtersList,
    search,
    bulkAll,
  }: {
    workflowId: string
    applyFilters: boolean
    filtersList?: IResponseFilterSegment[]
    search?: string
    bulkAll?: boolean
  }) =>
    WorkflowsApi.enrollIntoWorkflow(
      {
        contact_filters: filtersList,
        apply_trigger_filters: applyFilters,
        search,
        apply_to_all: bulkAll,
      },
      workflowId
    ).then(
      () => {
        toastStore.add({
          type: 'success',
          title: 'Contacts will be enrolled in workflow',
        })

        return true
      },
      () => {
        toastStore.add({
          type: 'error',
          title: 'Unable to engage contacts',
        })

        return false
      }
    )
}
